import { Logging } from '#common/logging';
import { InvalidStateError } from '#common/types';
import { SettingName, SettingTarget } from '#config/types';
export const createStsConfigFetcher = (configManager) => {
    return new StsConfigFetcherImpl(configManager);
};
class StsConfigFetcherImpl {
    configManager;
    log = Logging.getLogger('StsConfigFetcher');
    constructor(configManager) {
        this.configManager = configManager;
    }
    async fetchStsConfig() {
        const stsConfig = await this.configManager.get([
            {
                target: SettingTarget.STS,
                name: SettingName.STS_CREDENTIALS,
            },
        ]);
        const stsConfigValue = stsConfig[0].effective().asMultiString();
        if (stsConfigValue.length < 4) {
            this.log.warn('Fetched invalid STS config');
            throw new InvalidStateError('Invalid STS config');
        }
        return {
            accessKey: stsConfigValue[0],
            secretKey: stsConfigValue[1],
            sessionToken: stsConfigValue[2],
            expiration: new Date(Number(stsConfigValue[3])),
        };
    }
    async fetchRefreshIntervalMs() {
        const setting = await this.configManager.get([
            {
                target: SettingTarget.STS_SETTING,
                name: SettingName.STS_REFRESH_INTERVAL,
            },
        ]);
        return Number(setting[0].effective().asUint64());
    }
}
